import { render, staticRenderFns } from "./security.vue?vue&type=template&id=80fc9692&scoped=true"
import script from "./security.vue?vue&type=script&lang=js"
export * from "./security.vue?vue&type=script&lang=js"
import style0 from "./security.vue?vue&type=style&index=0&id=80fc9692&prod&lang=scss&scoped=true"
import style1 from "./security.vue?vue&type=style&index=1&id=80fc9692&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fc9692",
  null
  
)

export default component.exports